import React from "react"
import {
  PAGE_NOT_FOUND_BODY_TEXT,
  PAGE_NOT_FOUND_HEADING_TEXT,
} from "../../constants"
import {
  Heading2,
  PageContainer,
  PageSection,
  ParagraphText,
} from "../../UIKit/styles"

export default function NotFound() {
  return (
    <PageContainer>
      <Heading2>{PAGE_NOT_FOUND_HEADING_TEXT}</Heading2>
      <PageSection>
        <ParagraphText>{PAGE_NOT_FOUND_BODY_TEXT}</ParagraphText>
      </PageSection>
    </PageContainer>
  )
}
